import { createContext, useContext, useEffect, useState, ReactNode } from "react";

interface Head {
    title?: string;
    description?: string;
    canonical?: string;
}

const HeadContext = createContext<(head: Head) => void>(() => {});

export const HeadProvider = ({ children }: { children: ReactNode }) => {
    const [head, setHead] = useState<Head>({});

    useEffect(() => {
        if (head.title) {
            document.title = head.title;
            document.querySelector('meta[property="og:title"]')?.setAttribute("content", head.title);
        }
        if (head.description) {
            document.querySelector('meta[name="description"]')?.setAttribute("content", head.description);
            document.querySelector('meta[property="og:description"]')?.setAttribute("content", head.description);
        }
        if (head.canonical) {
            let link = document.querySelector('link[rel="canonical"]');
            if (!link) {
                link = document.createElement("link");
                link.setAttribute("rel", "canonical");
                document.head.appendChild(link);
            }
            link.setAttribute("href", head.canonical);
        }
    }, [head]);

    return <HeadContext.Provider value={setHead}>{children}</HeadContext.Provider>;
};

export const useHead = (title: string, description: string, canonical: string) => {
    const setHead = useContext(HeadContext);
    useEffect(() => {
        setHead({ title, description, canonical });
    }, [title, description, canonical, setHead]);
};
